<div class="h-3 md:h-4 w-full flex flex-row justify-end items-center">
    <div class="w-[40%] h-full {{ brand.isLexus() ? 'bg-lexusBlue' : 'bg-toyotaRed' }}"></div>
</div>
